import { createContext } from 'react';
import type { User } from '../../api/types';

export interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  /** Update in-memory user fields (e.g. after toggling active) */
  updateUser: (patch: Partial<User>) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
